var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramHealthInsurance64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "56px",
    viewBox: "0 0 44 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.500223,0 C25.6866986,0 29.0805077,3.28425466 29.0805077,7.33558809 C29.0805077,9.50689098 28.1056701,11.4578582 26.5564295,12.8009816 L14.8578036,25.3720274 L3.28986064,12.895639 C1.67612898,11.5503986 0.65443998,9.55845594 0.65443998,7.33558809 C0.65443998,3.28425466 4.04824905,0 8.2347247,0 C11.0890819,0 13.5749624,1.52670923 14.8679559,3.78232992 C16.1599853,1.52670923 18.6458657,0 21.500223,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FINAL-Responsive-***",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D_NB_Inlife",
    transform: "translate(-165.000000, -296.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contents",
    transform: "translate(142.000000, 259.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(24.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pictogram",
    transform: "translate(0.538586, 0.194453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.461414, 0.805547)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-3",
    stroke: "#4F4C4D",
    strokeWidth: 2,
    fill: "#FFFFFF",
    points: "0 0 40 0 40 39.3125 20 51 0 39.3125"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Focus",
    fill: "#FFCC00",
    points: "20 1 39 1 39 23 20 23"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 20.4614145,
    y1: 50.805547,
    x2: 20.4614145,
    y2: 0.805547021,
    id: "Line-4",
    stroke: "#4F4C4D",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./Health64*",
    transform: "translate(6.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Health",
    transform: "translate(0.345560, 0.383531)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    stroke: "#4F4C4D",
    strokeWidth: 2,
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }))), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#4F4C4D",
    strokeWidth: 2,
    points: "1 25 16 25 19 21 22 29 26 25 41 25"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramHealthInsurance64);
export default __webpack_public_path__ + "static/media/pictogramHealthInsurance64.8fca025ead8ea96826902252df7a9586.svg";
export { ForwardRef as ReactComponent };